// All Memory Wall copy. Voice: confident with edge, on-theme with ETERNITY.
export const MEMORY = {
  bandHeading: 'Leave a memory\nyou never want to lose',
  bandSub: 'It joins the wall. It fades unless people keep it alive.',
  placeholder: 'your memory…',
  initialsPlaceholder: 'J.R.',
  submit: 'LEAVE IT',
  submitting: 'LEAVING…',
  successHeading: "It's on the wall.",
  queuedNote: 'Your memory is being read. It appears for everyone once it clears.',
  rejected: "That memory couldn't be posted.",
  tooMany: "You've already left a memory today.",
  recentLabel: 'Just left on the wall',
  viewWall: 'VIEW THE FULL WALL →',
  wallTitle: 'The Wall',
  wallEmpty: 'Be the first to leave a memory.',
  wallError: 'The wall is unavailable right now.',
  keep: 'keep',
  keepExplain: 'Tap KEEP on a memory to keep it from fading — the more it’s kept, the longer it stays. Unkept memories slowly decay and drift into the Archive.',
  pageTitle: 'The Memory Wall — ETERNITY | Maximum Productions',
  pageDesc: 'Leave a memory you never want to lose. It joins the wall, and fades unless people keep it alive. From ETERNITY, a cyberpunk short about immortality and loss.',
};
